import cleanedFilename from '~/util/cleanedFilename';

export default {
  CHECK_AVAILABILITY_BUTTON: `${cleanedFilename(
    __filename,
  )}-check-availability-button`,
  CONFIRM_BUTTON: `${cleanedFilename(__filename)}-confirm-button`,
};
